module.exports = __webpack_public_path__ + "img/actions-success.8b87cdb7.svg";